import { render, staticRenderFns } from "./LicenseInformation.vue?vue&type=template&id=54d9897b"
import script from "./LicenseInformation.vue?vue&type=script&lang=js"
export * from "./LicenseInformation.vue?vue&type=script&lang=js"
import style0 from "./LicenseInformation.vue?vue&type=style&index=0&id=54d9897b&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d9897b')) {
      api.createRecord('54d9897b', component.options)
    } else {
      api.reload('54d9897b', component.options)
    }
    module.hot.accept("./LicenseInformation.vue?vue&type=template&id=54d9897b", function () {
      api.rerender('54d9897b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Menu/LicenseInformation.vue"
export default component.exports